<div class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Cart Status</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <!-- <button  class="btn btn-outline-primary btn-sm " (click)="onAddDataEntity()"><img src="assets/images/Add_24.png"></button> -->
                 
               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  "  style="background-color: #d2e1f5; border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                        <!-- [ngClass]="{'activity' :showItinerary}" -->
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(clientInfo)"  >Client Information</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"    (click)="scroll(cartInfo)"   >Cart Information</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(itineraryInfo)"  >Itinerary Information</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"   (click)="scroll(reportingTags)"  >Reporting Tags</span></span>


                    </div>
                      
                    </div>

                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                     <div  class="col-md-12 card" style="min-height: 100%;" >

                      <div class="  mt-1 " style="padding: 10px;padding-bottom: 380px;">
                       
                        <div #clientInfo class="col-md-12 title"style="max-height: 45px;" >
                            Client Information
                        </div>

                        <div class="col-md-12 " >
                         
                            <table class="styled-Upper-table mt-3" style="margin: 0; padding: 0;width: 100%;">
                            
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr style="background-color: #f2f2f2;">
                                    <!-- Display structured data -->
                                   
                                    <td class="name-type" >Client Name</td>
                                    <td  class="" style="background-color: #ffffff;min-width:300px;">
                                      <!-- Interpret the character and display accordingly -->
                                      {{airData?.corporate.split('-')[1]||'-'}}
                                      <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" >Billing Entity	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:300px;">
                                      <!-- Interpret the character and display accordingly -->
                                      {{billingEntity||'-'}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    
                                  </tr>
                                 
                                  
                                </tbody>
                              </table>  
                          
                          </div>
                          
                          <div #cartInfo class="col-md-12 title mt-2"style="max-height: 50px;" >
                            Cart Information  
                          </div>

                        <div class="col-md-12 " style="overflow:auto">
                         
                            <table class="styled-Upper-table mt-3 " style="margin: 0; padding: 0;width: 100%;">
                            
                                <tbody>
                                  <!-- Iterate through dynamic data rows -->
                                  <tr style="background-color: #f2f2f2;">
                                    <!-- Display structured data -->
                                    <td class="name-type" >Cart Id</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                     {{airData?.uuid||'-'}}
                                    </td>
                                    <td class="name-type" >Request Id</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                     {{airData?.requestUuid||'-'}}
                                    </td>
                                    <td class="name-type" ></td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                     
                                    </td></tr>
                                  <tr style="background-color: #f2f2f2;">
                                    <!-- Display structured data -->
                                   
                                    <td class="name-type" >Generation Time		</td>
                                    <td  class="" style="background-color: #ffffff;min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
                                     {{formatDate(airData?.creationTs)||'-'}}
                              <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" >Booking Status</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
                                      <button *ngIf="airData.status==='N'"  disabled style="background-color:#4986E8;color:white;min-width: 130px;" mat-flat-button>NEW</button>
                                    <button *ngIf="airData.status==='B'"  disabled style="background-color:#44D43B;;color:white;min-width: 130px;" mat-flat-button>BOOKED</button>
                                    <button *ngIf="airData.status==='Z'"  disabled style="background-color:#FEC000;;color:white;min-width: 130px;" mat-flat-button>PARTIALLY BOOKED</button>
                                    <button  *ngIf="airData.status==='F'||airData.status==='S'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>FAILED</button>
                                   <button *ngIf="airData.status==='P'"  disabled style="background-color:#9ed43b;;color:white;min-width: 130px;" mat-flat-button>In Progress</button>

                                    <button  *ngIf="airData.status==='R'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PAYMENT FAILED</button>
                                    <button  *ngIf="airData.status==='T'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>PENDING TICKET</button>
                                    <button  *ngIf="airData.status==='A'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button>ABORTED</button>
                                    <button  *ngIf="airData.status==='TC'" style="background-color:#FF0000;color:white;min-width: 140px;" mat-flat-button >TO CANCEL</button>
                                    <button  *ngIf="airData.status==='C'" style="background-color:#FFA500;color:white;min-width: 140px;" mat-flat-button>CANCELLED</button>          <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    <button  *ngIf="airData.status==='X'" style="background-color:#ff5e00;color:white;min-width: 140px;" mat-flat-button>Partially Cancelled</button>
                                    <button  *ngIf="airData.status==='CR'" style="background-color:#c70d0d;color:white;min-width: 140px;" mat-flat-button>Cancellation Requested</button>
                                    <button  *ngIf="airData.status==='PS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button>Partially Reschedule</button>
                                    <button  *ngIf="airData.status==='RS'" style="background-color:#FEC000;;color:white;min-width: 140px;" mat-flat-button> Rescheduled</button>

                                  </td> 
                                    <td class="name-type" >Approval Type	</td>
                                    <td class="" style="background-color: #ffffff; min-width:200px;" >
                                      <!-- Interpret the character and display accordingly -->
                                     {{''}}                             <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                  </tr>
                                  <tr style="background-color: #f2f2f2; ">
                                    <!-- Display structured data -->
                                    <td class="name-type" >Approval Status	
                                    </td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
                                      {{airData?.approvalStatus==='SA'?('SELF APPROVED'):''}}
                                      {{airData?.approvalStatus==='P'?('PENDING'):''}}
                                      {{airData?.approvalStatus==='D'?('DECLINED'):''}}
                                      {{airData?.approvalStatus==='A'?('APPROVED'):''}}
                      
                                      {{airData?.approvalStatus==='I'?('APPROVAL INITIATED'):''}}
                                      {{airData?.approvalStatus==='S'?('SEND FOR RECONSIDERATION'):''}}                     <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" 
                                    >Travel Type	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px;">
                                      <!-- Interpret the character and display accordingly -->
{{''}}  
                              <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                    <td class="name-type" >Trip Booking Id	</td>
                                    <td  class="" style="background-color: #ffffff; min-width:200px">
                                      <!-- Interpret the character and display accordingly -->
                                      {{""}}
                              <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                    </td>
                                  </tr>
                                 
                                </tbody>
                                <tbody>
                                    <tr style="background-color: #f2f2f2; ">
                                        <!-- Display structured data -->
                                        <th class="name-type" >Notes
                                        </th>
                                        <th  class="" style="background-color: #ffffff; min-width:200px;">
                                          <!-- Interpret the character and display accordingly -->
                                         {{''}}                        <!-- Add additional conditions for other types of data (blank fields, etc.) -->
                                        </th></tr>
                                </tbody>
                              </table>  
                          
                          </div >
                        <span #itineraryInfo></span>
                          <div  *ngIf="airData && airData.airItineraries.length!=0" class="col-md-12 title mt-2" style="max-height: 50px;" >
                            <div  ><span>{{cityFilter(flights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(lastflight?.toAirport)}}</span> <span *ngIf="flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(flights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
                                                  </div>

                        <div class="col-md-12 row" *ngIf="airData&& airData.airItineraries.length!=0">

                            <div class="flights pt-3" *ngFor="let item of flights?.flightDetails?.flightDetailsList">
                                <div class="flight-details">
                                  <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                   
                                  <div class="carrier-info">
                                    <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                    <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                  </div>
                                </div>
                                <svg class="line" width="1200" height="100" >
                                    
                                    <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                    <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                    <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
            
                                    <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                    <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
              
                                    <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                  </svg>
                                

                                 
                              </div>
                              <div class="col-md-12 mt-3" >
                                <table class="styled-tables ">
                                    <thead>
                                      <tr >
                                        <!-- Dynamic headers based on tableHeaders array -->
                                        <th style="padding: 8px;  text-align: center;">Passenger	</th>
                                        <th style="padding: 8px;  text-align: center;">Status</th>
                                        <th style="padding: 8px;  text-align: center;">Class</th>
                                        <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                        <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                        <th style="padding: 8px;  text-align: center;">Basis</th>
                                        <th style="padding: 8px;  text-align: center;">Total Price</th>
    
    
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <!-- Iterate through dynamic data rows -->
                                      <ng-container *ngFor="let passengerDetail of flights?.orderPassengerDetails; let i=index">
                                      <tr >
                                        <!-- Display structured data -->
                                        <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                       ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                        <td class="" style="padding: 8px;">{{passengerDetail?.pnrStatus}}</td>
                                        <td class="name-type" style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.bookingClass}}</td>
                                        <td class="" style="padding: 8px;">{{passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr}}</td> 
                                        <td class="name-type" style="padding: 8px;">{{passengerDetail?.ticketNumber}}</td>
                                        <td class="" style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareBasis}}</td>
                                        <td class="name-type" style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare+passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax}} INR</td>
    
    
                                      </tr>

                                      <tr *ngIf="i < flights?.orderPassengerDetails.length">
                                        <td colspan="7" style="text-align: left; padding-left: 4px; font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{flights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(flights.supplierPayment)}}</td>


                                        <!-- <td colspan="7" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                                        
                                      </tr>
                                    </ng-container>
                                    </tbody>
                                  </table>
    
    
                        </div> 
                              <mat-divider class="mt-2 mb-2 "></mat-divider>
                              <div *ngIf="airData && airData.airItineraries.length!=0" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >

                              <div *ngIf="returnFlights"  ><span>{{cityFilter(returnFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(returnLastFlight?.toAirport)}}</span> <span *ngIf="returnFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(returnFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
                             </div>
                              <span *ngIf="returnFlights" >
                              <div  class="flights pt-3" *ngFor="let item of returnFlights?.flightDetails?.flightDetailsList">
                                  <div class="flight-details">
                                    <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
            
                                    <div class="carrier-info">
                                      <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                      <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                    </div>
                                  </div>
                                  <svg class="line" width="1200" height="100" >
                                      
                                      <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                      <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                      <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
              
                                      <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                      <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
                
                                      <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                    </svg>
                                  
                                </div>
                            
                                <div class="col-md-12 mt-3" >
                                    <table class="styled-tables ">
                                        <thead>
                                          <tr >
                                            <!-- Dynamic headers based on tableHeaders array -->
                                            <th style="padding: 8px;  text-align: center;">Passenger	</th>
                                            <th style="padding: 8px;  text-align: center;">Status</th>
                                            <th style="padding: 8px;  text-align: center;">Class</th>
                                            <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                            <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                            <th style="padding: 8px;  text-align: center;">Basis</th>
                                            <th style="padding: 8px;  text-align: center;">Total Price</th>
        
        
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <ng-container *ngFor="let passengerDetail of returnFlights?.orderPassengerDetails; let i=index">
                                          <!-- Iterate through dynamic data rows -->
                                          <tr >
                                            <!-- Display structured data -->
                                            <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                           ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                           <td class="" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                                           <td class="name-type" style="padding: 8px;">{{passengerDetail?.fareDetails?.bookingClass}}</td>
                                            <td class="" style="padding: 8px;">{{passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr}}</td>
                                            <td class="name-type" style="padding: 8px;">{{passengerDetail?.ticketNumber}}</td>
                                            <td class="" style="padding: 8px;">{{passengerDetail?.fareDetails?.fareBasis||'-'}}</td>
                                            <td  style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare+passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax}} INR</td>
        
        
                                          </tr>

                                          <tr *ngIf="i < returnFlights?.orderPassengerDetails.length">
                                            <td colspan="7" style="text-align: left; padding-left: 4px; font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{returnFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(returnFlights.supplierPayment)}}</td>

                                            <!-- <td colspan="7" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                                            
                                          </tr>
                                        </ng-container>
                                        </tbody>
                                      </table>
        
        
                            </div> 
                            </span>
                          
                          
 <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Third Flight+++++++++++++++++++++++++++++++++++++++++++++++-->




                            <mat-divider class="mt-2 mb-2 "></mat-divider>
                            <div *ngIf="airData && airData.airItineraries.length!=0&&thirdFlights" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >

                            <div *ngIf="thirdFlights"  ><span>{{cityFilter(thirdFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(thirdLastFlight?.toAirport)}}</span> <span *ngIf="thirdFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(thirdFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
                           </div>
                            <span *ngIf="thirdFlights" >
                            <div  class="flights pt-3" *ngFor="let item of thirdFlights?.flightDetails?.flightDetailsList">
                                <div class="flight-details">
                                  <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">
          
                                  <div class="carrier-info">
                                    <div>{{ fligthNameFilter(item?.carrierName )}}</div>
                                    <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
                                  </div>
                                </div>
                                <svg class="line" width="1200" height="100" >
                                    
                                    <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
                                    <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
                                    <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>
            
                                    <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
                                    <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>
              
                                    <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
                                  </svg>
                                
                              </div>
                          
                              <div class="col-md-12 mt-3" >
                                  <table class="styled-tables ">
                                      <thead>
                                        <tr >
                                          <!-- Dynamic headers based on tableHeaders array -->
                                          <th style="padding: 8px;  text-align: center;">Passenger	</th>
                                          <th style="padding: 8px;  text-align: center;">Status</th>
                                          <th style="padding: 8px;  text-align: center;">Class</th>
                                          <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                                          <th style="padding: 8px;  text-align: center;">Ticket No</th>
                                          <th style="padding: 8px;  text-align: center;">Basis</th>
                                          <th style="padding: 8px;  text-align: center;">Total Price</th>
      
      
                                        </tr>
                                      </thead>
                                      <tbody>
                                      <ng-container *ngFor="let passengerDetail of thirdFlights?.orderPassengerDetails;let i=index">

                                        <!-- Iterate through dynamic data rows -->
                                        <tr >
                                          <!-- Display structured data -->
                                          <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                                         ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                                         <td class="" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                                         <td class="name-type" style="padding: 8px;">{{passengerDetail?.fareDetails?.bookingClass}}</td>
                                          <td class="" style="padding: 8px;">{{passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr}}</td>
                                          <td class="name-type" style="padding: 8px;">{{passengerDetail?.ticketNumber}}</td>
                                          <td class="" style="padding: 8px;">{{passengerDetail?.fareDetails?.fareBasis||'-'}}</td>
                                          <td  style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare+passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax}} INR</td>
      
      
                                        </tr>

                                        <tr *ngIf="i < thirdFlights?.orderPassengerDetails.length">
                                          <td colspan="7" style="text-align: left; padding-left: 4px; font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{thirdFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(thirdFlights.supplierPayment)}}</td>

                                          <!-- <td colspan="7" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                                          
                                        </tr>
                                      </ng-container>
                                      </tbody>
                                    </table>
      
      
                          </div> 
                          </span>

<!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->
      <!--+++++++++++++++++++++++++++++++++++++ Fourth Flight+++++++++++++++++++++++++++++++++++++++++++++++-->



      <mat-divider class="mt-2 mb-2 "></mat-divider>
      <div *ngIf="airData && airData.airItineraries.length!=0&&fourthFlights" class="col-md-12 title mt-2" style="max-height: 50px;margin-left: 10px;" >

      <div *ngIf="fourthFlights"  ><span>{{cityFilter(fourthFlights?.flightDetails?.flightDetailsList[0]?.fromAirport)}}</span><span style="padding-left: 5px;"><mat-icon style="font-size: 15px;padding-top: 10px; ">arrow_forward</mat-icon></span><span>{{cityFilter(fourthLastFlight?.toAirport)}}</span> <span *ngIf="fourthFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime" style="color: rgb(150, 144, 144);"> {{dateFormate(fourthFlights?.flightDetails?.flightDetailsList[0]?.schDepartureTime)}}</span></div>
     </div>
      <span *ngIf="fourthFlights" >
      <div  class="flights pt-3" *ngFor="let item of fourthFlights?.flightDetails?.flightDetailsList">
          <div class="flight-details">
            <img class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">

            <div class="carrier-info">
              <div>{{ fligthNameFilter(item?.carrierName )}}</div>
              <div class="flight-number">{{ item?.carrierName }} - {{ item?.flightNumber }}</div>
            </div>
          </div>
          <svg class="line" width="1200" height="100" >
              
              <circle fill="#999" cx="4.5" cy="4.5" r="4.5"></circle>
              <text x="59.5" y="15" text-anchor="start" font-size="14"  fill="#000">{{ timeFormate(item?.schDepartureTime) }} {{item?.fromAirport}} {{airPortFilter(item?.fromAirport)}} {{item?.fromTerminal?("Terminal "+item?.fromTerminal):''}}</text>
              <text x="59.5" y="50.5" text-anchor="start" font-size="16" fill="#000">⌚ {{ converter(item?.travelDuration) }}</text>

              <circle fill="#999" cx="4.5" cy="92.5" r="4.5"></circle>
              <text x="59.5" y="83.5" text-anchor="start"  font-size="14" fill="#000">{{ timeFormate(item?.schArrivalTime)}} {{item?.toAirport}} {{airPortFilter(item?.toAirport)}} {{item?.toTerminal?("Terminal "+item?.toTerminal):''}}</text>

              <path stroke="#999" stroke-linecap="square" stroke-dasharray="7" d="M4.5 7v84"></path>
            </svg>
          
        </div>
    
        <div class="col-md-12 mt-3" >
            <table class="styled-tables ">
                <thead>
                  <tr >
                    <!-- Dynamic headers based on tableHeaders array -->
                    <th style="padding: 8px;  text-align: center;">Passenger	</th>
                    <th style="padding: 8px;  text-align: center;">Status</th>
                    <th style="padding: 8px;  text-align: center;">Class</th>
                    <th style="padding: 8px;  text-align: center;">Airline PNR</th>
                    <th style="padding: 8px;  text-align: center;">Ticket No</th>
                    <th style="padding: 8px;  text-align: center;">Basis</th>
                    <th style="padding: 8px;  text-align: center;">Total Price</th>


                  </tr>
                </thead>
                <tbody>
                  <!-- Iterate through dynamic data rows -->
                <ng-container *ngFor="let passengerDetail of fourthFlights?.orderPassengerDetails;let i=index">

                  <tr >
                    <!-- Display structured data -->
                    <td class="" style="padding: 8px;">{{ passengerDetail?.title }} {{ passengerDetail?.firstName }} {{ passengerDetail?.lastName }}
                   ({{passengerDetail?.passengerType==='ADT'?('Adult'):''||passengerDetail?.passengerType==='CHD'?('Child'):''||passengerDetail?.passengerType==='CH'?('Child'):''||passengerDetail?.passengerType==='CNN'?('Child'):''||passengerDetail?.passengerType==='INF'?('Infant'):''||passengerDetail?.passengerType==='IN'?('Infant'):''}})</td>
                   <td class="" style="padding: 8px;">{{passengerDetail?.pnrStatus||'-'}}</td>
                   <td class="name-type" style="padding: 8px;">{{passengerDetail?.fareDetails?.bookingClass}}</td>
                    <td class="" style="padding: 8px;">{{passengerDetail.providerPnrNumber?(passengerDetail.providerPnrNumber):passengerDetail.pnr}}</td>
                    <td class="name-type" style="padding: 8px;">{{passengerDetail?.ticketNumber}}</td>
                    <td class="" style="padding: 8px;">{{passengerDetail?.fareDetails?.fareBasis||'-'}}</td>
                    <td  style="padding: 8px;">{{passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare+passengerDetail?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax}} INR</td>


                  </tr>
                  <tr *ngIf="i < fourthFlights?.orderPassengerDetails.length">
                    <td colspan="7" style="text-align: left; padding-left: 4px; font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}<br><strong>{{passengerDetail?.seatMeal?.seatMeal?('Seat Meal:'):''}}</strong>{{displayWEJSON(passengerDetail?.seatMeal?.seatMeal)}}<br><strong>{{fourthFlights.supplierPayment?('Supplier Payment:'):''}}</strong>{{displayWEJSON(fourthFlights.supplierPayment)}}</td>

                    <!-- <td colspan="7" style="text-align: left; padding-left: 4px;font-size: small;color: gray;">{{displayJSON(passengerDetail.fareDetails.passengerBookingClasses[0])}}</td> -->
                    
                  </tr>
                </ng-container>
                </tbody>
              </table>


    </div> 
    </span>




                          </div>
                    
                         
                          <div class="col-md-12 mt-4"  >
                            <div  class="col-md-12 card"  >
              
                             <div  class="  mt-1 " style="padding: 10px; ">
                              
                               <div #reportingTags class="col-md-12 title"style="max-height: 45px;" >
                                   Reporting Tags
                               </div>
              
                               <div class="col-md-12 " style="overflow-y:auto">
                                <span *ngFor="let rmtags of passengerDetails(airData.airItineraries[0].orderPassengerDetails);let i=index">
                                  <div style="padding: 4px;" style="text-align: left;" class="name-type">Adult {{i+1}}</div>
                                   <table  class="styled-tables mt-3" style="margin: 0; padding: 0;width: 100%;">
                                    <!-- <thead>
                                      <tr >
               <th class="name-type">Name</th>
              <th class="name-type">Display Name</th>
              <th class="name-type">Value</th>
              <th class="name-type">Invoiceable</th>
              
                                      </tr>
                                    </thead> -->
              
                                       <tbody>
                                         <!-- Iterate through dynamic data rows -->
                                         <tr style="background-color: #f2f2f2;"  *ngFor="let tags of rmtags.rmTags">
                                           <!-- Display structured data -->
                                          
                                           <!-- <td  class="" >{{tags.name}}  </td>
                                            <td  class="" >{{tags.displayName}}  </td>
                                              <td  class="" >{{tags.value}}  </td>
                                                <td  class="" >{{tags.invoiceable}}</td>  </tr>
               -->
               <td  class="name-type" style="text-align: left;width: 150px;padding: 4px;">{{tags.displayName||tags.name}}  </td>
               <td  class="" style="text-align: left;padding: 4px;background-color: white;" >{{tags.value}}  </td>

          
                                       </tbody>
                                     </table>  
                                    </span>
              
              </div>
              </div>
              </div>
              </div>
                      
                      </div>
                     
                    </div>
                    </div>
                </div>

             
                